import type {FieldView} from '@api/field/api.d';
import type {ConditionView} from '@api/conditionalField/api.d';
import {FIELD_TYPES} from '@api/constants';

interface GetIsConditionSourceArgs {
    fieldId: string;
    fields?: FieldView[];
    conditions?: ConditionView[];
}

function getIsRadioField(field?: FieldView): boolean {
    return field?.type?.toLowerCase() === FIELD_TYPES.RADIO;
}

/** Radio siblings count as sources too: selecting one reverses the conditions of the option being left (JDT-1542). */
export function getIsConditionSource({
    fieldId, fields = [], conditions = []
}: GetIsConditionSourceArgs): boolean {
    const hasOwnConditions = conditions.some((condition) => condition.field_id === fieldId);

    if (hasOwnConditions) {
        return true;
    }

    const field = fields.find(({id}) => id === fieldId);

    if (!getIsRadioField(field) || !field?.group) {
        return false;
    }

    return fields.some((sibling) => sibling.group === field.group
        && getIsRadioField(sibling)
        && conditions.some((condition) => condition.field_id === sibling.id));
}
